import React from 'react';

const skeletonKeyframes = `
  @keyframes pulse {
    0%, 100% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
  }
`;

const LoadingSkeleton = ({ width = '100%', height = '16px', borderRadius = '4px', style = {} }) => {
  return (
    <>
      <style>{skeletonKeyframes}</style>
      <div
        style={{
          width,
          height,
          borderRadius,
          backgroundColor: '#21262d',
          animation: 'pulse 1.5s ease-in-out infinite',
          ...style
        }}
      />
    </>
  );
};

export const TableRowSkeleton = ({ columns = 6 }) => {
  return (
    <tr style={{ borderBottom: '1px solid #30363d' }}>
      {Array.from({ length: columns }).map((_, i) => (
        <td key={i} style={{ padding: '12px 16px' }}>
          <LoadingSkeleton
            width={i === 0 ? '80%' : i === columns - 1 ? '60px' : '70%'}
            height="16px"
          />
          {i === 0 && (
            <LoadingSkeleton
              width="50%"
              height="12px"
              style={{ marginTop: '8px' }}
            />
          )}
        </td>
      ))}
    </tr>
  );
};

export const StatCardSkeleton = () => {
  return (
    <div style={{
      backgroundColor: '#161b22',
      border: '1px solid #30363d',
      borderRadius: '8px',
      padding: '16px',
      textAlign: 'center'
    }}>
      <LoadingSkeleton
        width="60%"
        height="24px"
        style={{ margin: '0 auto 8px auto' }}
      />
      <LoadingSkeleton
        width="80%"
        height="12px"
        style={{ margin: '0 auto' }}
      />
    </div>
  );
};

export const CardSkeleton = () => {
  return (
    <div style={{
      backgroundColor: '#161b22',
      border: '1px solid #30363d',
      borderRadius: '8px',
      padding: '20px',
      marginBottom: '16px'
    }}>
      <LoadingSkeleton width="40%" height="20px" style={{ marginBottom: '12px' }} />
      <LoadingSkeleton width="100%" height="14px" style={{ marginBottom: '8px' }} />
      <LoadingSkeleton width="80%" height="14px" style={{ marginBottom: '8px' }} />
      <LoadingSkeleton width="60%" height="14px" />
    </div>
  );
};

export default LoadingSkeleton;
